import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import BusinessSummary from './components/BusinessSummary';
import VisionCTA from './components/VisionCTA';
import { SEO } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '株式会社ガイアライブラリー',
    url: siteUrl,
    logo: `${siteUrl}/vite.svg`,
    description: 'ブロックチェーンとAIを活用し、アジアと日本の暮らしを豊かにする企業。インドネシアでのステーブルコイン事業、AI健康アプリ「クラティブ」、コーヒー輸入、防水コンクリート技術を展開。',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '渡辺通五丁目14番12号南天神ビル3階',
      addressLocality: '福岡市中央区',
      addressRegion: '福岡県',
      postalCode: '810-0004',
      addressCountry: 'JP'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 33.589012,
      longitude: 130.401234
    },
    founder: {
      '@type': 'Person',
      name: '鈴山　慎一郎'
    },
    areaServed: ['JP', 'ID'],
    knowsAbout: ['ブロックチェーン', 'AI', 'ステーブルコイン', '健康DX', 'コーヒー輸入', '防水コンクリート']
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="株式会社ガイアライブラリー｜福岡ブロックチェーンAI健康DX"
        description="株式会社ガイアライブラリーは、インドネシアでのステーブルコイン事業、AI健康アプリ「クラティブ」、コーヒー輸入、防水コンクリート技術など、ブロックチェーンとAIを活用し、アジアと日本の暮らしを豊かにする企業です。福岡市中央区に本社を置き、デジタル情報の信頼性と暮らしのDXを推進しています。"
        keywords="ガイアライブラリー,ステーブルコイン,ブロックチェーン,AI,クラティブ,健康DX,コーヒー輸入,防水コンクリート,福岡,インドネシア"
        schema={schema}
      />
      <HeroSection />
      <BusinessSummary />
      <VisionCTA />
    </div>
  );
}
